let axios = require('axios');
let config = require('./config');


class RegistrationComponent {
    constructor() {
        this.api = {
            protocol: config.api.protocol,
            domain: config.api.url,
            createUserRoute: config.api.createUserRoute,
            loginurl: config.api.loginurl
        };
       this.registrationButton = $('.giveMeBizXpert');
       this.$demoBtn = $('.initDemo');
       this.collectionFields();
       this.registerClickEvent();
       //this.hideErrorMessageOnClick();
       this.errormsg = null;

       this.initDemo();
    }

    initDemo() {
        let that = this;
        that.$demoBtn.on('click', function () {
            ga('send', 'event', 'Demo', 'kattintas', 'Demo-oldal');
           location.href = that.api.protocol + that.api.domain + config.api.demouri;
        });
    }

    collectionFields() {
        //this.lname = $('#lname_field');
        this.fname = $('#fname_field');
        this.email = $('#email_field');
        this.password = $('#password_field');
        this.aszf = $('#aszf_chk');

        //
        //this.lname1 = $('#lname_field_1');
        this.fname1 = $('#fname_field_1');
        this.email1 = $('#email_field_1');
        this.password1 = $('#password_field_1');
        this.aszf1 = $('#aszf_chk_1');
        this.$newsletter_mobile = $('#newsletter_1');
        this.$newsletter_desktop = $('#newsletter_check_desktop');

        /*Thank you modal*/
        this.$goUri = $('.goToBizXpertModal');
        this.$thankYouModal = $('#ThankYouModal');

        /*Login element*/
        this.$loginElement = $('#goToBizXpert');

        /*captchform */
        this.$captcha= $('.g-recaptcha');
    }

    newsletterIsChecked() {

        if(this.dataform === 'desktop') {
            if(this.$newsletter_desktop.is(':checked') === true)
                return true;
            else
                return false;
        }else {
            if(this.$newsletter_mobile.is(':checked') === true) {
                return true;
            }else {
                return false;
            }
        }
    }

    completeRegistration(recaptcha, dataform) {
        let that = this;
        that.dataform = dataform;

        if(!recaptcha) {

            that.errormsg = "ReCaptcha field is missing!";
            $('body').append('<div class="alert alert-dange bzx-errormessage"> <strong>Hiba!</strong> '+ that.errormsg +'</div>');

            try {
                grecaptcha.reset();
            }catch (err) {

            }

            return;
        }

        that.registrationButton.css('pointer-events', 'none');
        that.registrationButton.html('REGISZTRÁCIÓ FOLYAMATBAN...').css('background-color', '#828282');

        let registrationData = {};

        if(sessionStorage.getItem('RegistrationInfo') !== null) {
            registrationData = JSON.parse(sessionStorage.getItem('RegistrationInfo'));
            registrationData.rehash = recaptcha
        }
        else {
            registrationData = {
                fname: (that.dataform === 'desktop') ? that.fname.val() : that.fname1.val(),
                email: (that.dataform === 'desktop') ? that.email.val() : that.email1.val(),
                password: (that.dataform === 'desktop') ? that.password.val(): that.password1.val(),
                rehash: recaptcha,
                withtoken: true,
                logintype: 0,
                withoutlname: true,
                newsletter: that.newsletterIsChecked()
            }
        }

        axios.post(that.api.protocol + that.api.domain + that.api.createUserRoute, registrationData)
            .then(function(response){

                if(response.data.IsSuccess) {

                    dataLayer.push({'event': 'registration_complete'});
                    fbq('track', 'CompleteRegistration', {something:1});

                    that.$goUri.on('click', function () {
                        dataLayer.push({'event': 'after_registration_modal_click'});

                        location.href = that.api.protocol + that.api.domain + that.api.loginurl + response.data.response + '/0';
                    });
                    that.$thankYouModal.modal({backdrop: 'static', keyboard: false});

                    //Remove all filled input value
                    $('input').val('');

                    // it he modal is suddenly closed!
                    that.$loginElement.off('click');
                    that.$loginElement.on('click', function () {
                        location.href = that.api.protocol + that.api.domain + that.api.loginurl + response.data.response + '/0';
                    });

                }else {

                     try {
                         grecaptcha.reset();
                     }catch (err) {

                     }

                    dataLayer.push({'event': 'registration_faild'});
                    //show error messages
                    that.registrationButton.html('KÉREM <br /> AZ INGYEN SZÁMLÁZÓMAT').css('background-color', '#1f8f34');
                    that.errormsg = response.data.ErrorMsg;
                    $('body').append('<div class="alert alert-dange bzx-errormessage"> <strong>Hiba!</strong> '+ that.errormsg +'</div>');
                    that.registrationButton.css('pointer-events', 'visible');
                    that.hideErrorMessageOnClick();

                    /*Add input error */
                    if(response.data.response) {
                        let $field = (that.dataform === 'desktop') ? $('#' + response.data.response + '_field') :  $('#' + response.data.response + '_field_1');
                        $field.addClass('inputHasError');
                    }
                }

            });
    }

    errorMessage(errormessage) {
        $('body').append('<div class="alert alert-dange bzx-errormessage"> <strong>Hiba!</strong> '+ errormessage +'</div>');
        this.hideErrorMessageOnClick();
        this.hideErrorMessage();
    }

    registerClickEvent() {
        let that = this;

        this.registrationButton.on('click', function () {

            sessionStorage.removeItem('RegistrationInfo');

            that.removeAllInputErrors();

            that.dataform = $(this).attr('data-form') || 'desktop';
            that.$captcha.attr('data-action', that.dataform);

            let config = {
                headers: {'X-My-Custom-Header': 'Header-Value'}
            };
            that.hideErrorMessage();

            if(!that.checkAszfAccess()) {
                that.hideErrorMessageOnClick();
                return false;
            }

            try {
                grecaptcha.execute();
            }catch (err) {

            }

        });
    }

    hideErrorMessage() {
        $('.bzx-errormessage').animate({
            'right': '-800px'
        },200);
    }

    hideErrorMessageOnClick() {

        $('.bzx-errormessage').on('click', function () {
            $(this).animate({
                'right': '-800px'
            },200);
        });
    }

    checkAszfAccess() {

        let $aszfchk = (this.dataform === 'desktop') ? this.aszf : this.aszf1;

        if($aszfchk.is(':checked')) {
            return true;
        }else {
            $('body').append('<div class="alert alert-dange bzx-errormessage"> <strong>Hiba!</strong> Az ÁSZF elfogadása kötelező!</div>');
            return false;
        }
    }

    removeAllInputErrors() {
        $('input').removeClass('inputHasError');
    }

}

module.exports = RegistrationComponent;